import requests from 'api/index';

const prefixURL = '/employee/empsearch';

const userInfoParams = [
  'LOGINID',
  'USERID',
  'LOCALE',
  'MAIL',
  'THEME',
  'SORGID',
  'VOIPSTATUS',
  'VOIPNUMBER',
  'TIMEZONE',
  'ICODE',
  'MCODE',
  'IMCODE',
  'COOKIESAVEDYN',
  'COMPID',
  'DARKMODEYN',
  'USABLESVCLIST',
  'BIZCLSFCD',
  'LOGINMODE',
];

const USER_ROLES = {
  ROLE_PARTNER_SEARCH: 'ROLE_PARTNER_SEARCH',
  ROLE_HIDDEN_ORGTAB: 'ROLE_HIDDEN_ORGTAB',
  ROLE_E21_CSTMR: 'ROLE_E21_CSTMR',
  ROLE_BLOG_RESTRICT: 'ROLE_BLOG_RESTRICT',
  ROLE_ORG_NOPHONEGRID: 'ROLE_ORG_NOPHONEGRID',
  ROLE_ORG_JOBGRID: 'ROLE_ORG_JOBGRID',
  ROLE_EMP_JOBGRID: 'ROLE_EMP_JOBGRID',
  ROLE_INSTANT_RESTRICT: 'ROLE_INSTANT_RESTRICT',
  ROLE_CMP_DRTR: 'ROLE_CMP_DRTR',
  ROLE_PIMS_RESTRICT: 'ROLE_PIMS_RESTRICT',
  ROLE_SCH_RESTRICT: 'ROLE_SCH_RESTRICT',
  ROLE_HIDDEN_EMPNO: 'ROLE_HIDDEN_EMPNO',
  ROLE_OUT_RESTRICT: 'ROLE_OUT_RESTRICT',
  ROLE_TOTAL_RESTRICT: 'ROLE_TOTAL_RESTRICT',
  COOKIESAVEDYN: 'COOKIESAVEDYN',
  ROLE_WORKDAY: 'ROLE_WORKDAY',
  ROLE_SDESK_AUTH: 'ROLE_SDESK_AUTH',
  ROLE_CMP_MNGR: 'ROLE_CMP_MNGR',
  ROLE_LGPD_COMPANY: 'ROLE_LGPD_COMPANY',
  ROLE_ONLY_DFLT_IMG: 'ROLE_ONLY_DFLT_IMG',
  ROLE_USE_VOIP: 'ROLE_USE_VOIP',
  ROLE_PINFO_EDIT: 'ROLE_PINFO_EDIT'
};

export default {
  getUserInfo: () => requests.post(`${prefixURL}/rest/v1/userInfo`, userInfoParams),
  getUserInfoWithParam: payload => requests.post(`${prefixURL}/rest/v1/userInfo`, payload),
  hasRoles: () => {
    const roles = Object.values(USER_ROLES);
    return requests.get(`${prefixURL}/rest/v1/acl/hasRoles/${roles.join(',')}`);
  },
  getProperty: payload => requests.post(`${prefixURL}/rest/v1/property?key=${payload}`, {}),
  getDisasterRecoveryMode: () => requests.post(`${prefixURL}/rest/v1/property?key=ep.empsearch.dr`, {}),
  getPrioritySearchLimit: () => requests.post(`${prefixURL}/rest/v1/priosearch/limit`, {}),
  getPrioritySearchList: payload => requests.post(`${prefixURL}/rest/v1/priosearch/list`, payload),
  removePrioritySearch: payload => requests.post(`${prefixURL}/rest/v1/priosearch/deletes`, payload),
  addPrioritySearch: payload => requests.post(`${prefixURL}/rest/v1/priosearch/create`, payload),
  getThumbImg: payload => requests.get(`${prefixURL}/rest/v1/photo/thumb/enc/list?epid=${payload}`),
  addPhotoRegister: payload => requests.post(`${prefixURL}/rest/v1/photo/register`, payload),
  getImageEditorDomain: () => requests.post(`${prefixURL}/rest/v1/property?key=ep.image.editor.domain.address`, {}),
  addRecentEmp: payload => requests.post(`${prefixURL}/rest/v1/recent/create`, payload),
  addRecentContact: payload => requests.post(`${prefixURL}/rest/v1/recent/create/contact`, payload),
  addRecentContactGroup: payload => requests.post(`${prefixURL}/rest/v1/recent/create/contactgroup`, payload),
  makeURLGetPhotoOriginal: payload => {
    return `${prefixURL}/rest/v1/photo/original?epid=${payload}`;
  },
  makeURLGetQRCode: payload => {
    return `${prefixURL}/rest/v1/photo/qrcode?query=${payload}&size=235`;
  },
  getMeetingDomain: () => requests.post(`${prefixURL}/rest/v1/property?key=ep.meeting.domain`, {}),
  getDriveDomain: payload => requests.get(`${prefixURL}/rest/v1/emp/drive/url?compCd=${payload}`),
};
